import React, { useState, useContext, useEffect } from "react";
import {
  Navbar,
  Nav,
  Button,
  Modal,
  NavDropdown,
  Dropdown,
} from "react-bootstrap";
import "./NewHeader.css";
import originallogo1 from "../../../Assets/Images/logo.png";
import originallogo2 from "../../../Assets/Images/logo.png";
import chaticon from "../../../Assets/Images/chaticon.png";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import {
  LoginFormContext,
  LangContext,
  CompanyData,
  userTokenContext,
  ShoppingCart,
} from "../../../App";
import LoginForm from "../../../Views/Auth/Login/Login";
import cookie from "react-cookies";
import close from "../../../Assets/Images/close.png";
import { API_ENDPOINT } from "../../../AppConfig";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// import Lottie from "react-lottie";
// import animationData from "../../../Assets/lottieFiles/shoppingLoading.json";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import string from "../../../Assets/Localization/Local";
import iconwhats from "../../../Assets/Images/iconwhats.png";
import should from "../../../Assets/Images/should.png";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Header = (props) => {
  const { data } = useContext(CompanyData);
  const [closemenu, setCloseMenu] = useState(true);
  const { lang, changeLang } = useContext(LangContext);
  const { openLoginForm, ToggleLoginForm } = useContext(LoginFormContext);
  const [productname, setProductName] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const [showlogin, setShowLogin] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [hint, setHint] = React.useState(false);
  const [remove, setRemove] = React.useState(true);
  const [pathName, setPathName] = React.useState(null);
  const handleCloseLoginModal = () => setShowLogin(false);
  const handleShowLogin = () => setShowLogin(true);
  const [AllProducts, setAllProducts] = useState([]);
  const [AllCategories, setAllCategories] = useState([]);
  const [AllSubCategories, setAllSubCategories] = useState([]);
  const [hasChild, sethasChild] = useState(false);
  const [showImage, setShowImage] = React.useState(false);
  const handleCloseImageModal = () => setShowImage(false);
  const handleShowImage = () => setShowImage(true);
  const [SearchValue, setSearchValue] = useState("");
  const [path, setpath] = useState("");
  const [showSearch, setshowSearch] = React.useState(false);
  const [logOut, setLogOut] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const { handleUserToken } = useContext(userTokenContext);
  const { handleShoppingCart } = useContext(ShoppingCart);

  let currentUser_cookie = cookie.load("CatchItUser");
  let currentUser_session = JSON.parse(sessionStorage.getItem("CatchItUser"));
  let user = currentUser_session ? currentUser_session : currentUser_cookie;
  let token_cookie = cookie.load("CatchIt_token");
  let token_sessionStorage = sessionStorage.getItem("CatchIt_token");
  let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)
    }`;
  let newpath = window.location.pathname;
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const LogOutfn = () => {
    handleShoppingCart([]);
    localStorage.setItem("cart", null);
    localStorage.setItem("PROMO", null);

    // console.log('logout--> ')
    cookie.remove("CatchItUser", { path: "/" });
    cookie.remove("CatchIt_token", { path: "/" });
    sessionStorage.removeItem("CatchItUser");
    sessionStorage.removeItem("CatchIt_token");
    setLogOut(true);
    setRedirect(true);
    handleUserToken("");
  };
  useEffect(() => {
    fetchAllProducts();
    fetchAllCategories();
    setpath(window.location.pathname);
  }, []);


  useEffect(() => { }, [localStorage.getItem("Header")]);
  useEffect(() => {
    setPathName(props.locationpath);
  }, [props.locationpath]);
  const handleChange = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setImagePreviewUrl(URL.createObjectURL(file));
    setFile(file);
    handleShowImage();
  };
  const MannualOrder = () => {
    let url = `${API_ENDPOINT}/order/maual`;
    const SubmitData = new FormData();
    SubmitData.append("image", file);
    axios
      .post(url, SubmitData, {
        headers: { "Accept-Language": lang, Authorization: token },
      })
      .then((response) => {
        // setLoading(true);
        setRemove(false);
        setHint(string.successsendreq);
        setOpen(true);
        handleCloseImageModal();
      })
      .catch((error) => {
        // setLoading(false);
        handleCloseImageModal();
        if (!error.response) {
          setRemove(true);
          setHint(string.interneterror);
          setOpen(true);
        } else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setRemove(true);
            setHint(error.response.data.errors[i].msg);
            setOpen(true);
          }
        } else {
          setRemove(true);
          setHint(error.response.data.errors);
          setOpen(true);
        }
      });
  };

  const fetchAllProducts = () => {
    let country = JSON.parse(localStorage.getItem("Country"))
      ? JSON.parse(localStorage.getItem("Country")).id
      : null;
    let city = JSON.parse(localStorage.getItem("City"))
      ? JSON.parse(localStorage.getItem("City")).id
      : null;
    let region = JSON.parse(localStorage.getItem("Region"))
      ? JSON.parse(localStorage.getItem("Region")).id
      : null;
    let uri = `${API_ENDPOINT}/product?all=true&removeLanguage=true`;
    if (user) {
      uri += `&userId=${user.id}`;
    }
    if (country) {
      uri += `&country=${country}`;
    }
    if (city && city !== -1) {
      uri += `&city=${city}`;
    }
    if (region && region !== -1) {
      uri += `&region=${region}`;
    }
    axios
      .get(uri, {
        headers: {
          "Accept-Language": lang,
        },
      })
      .then((response) => {
        console.log("defe--> ", response.data.data);
        let temp = {},
          arr = [];
        for (let i = 0; i < response.data.data.length; i++) {
          temp = {
            name: response.data.data[i].name,
            id: response.data.data[i].id,
          };
          arr.push(temp);
          temp = {};
        }
        setAllProducts(arr);
      })
      .catch((error) => { });
  };
  const fetchAllCategories = () => {
    let uri = `${API_ENDPOINT}/category?all=true`;

    axios
      .get(uri, {
        headers: {
          "Accept-Language": lang,
        },
      })
      .then((response) => {
        console.log("category defe--> ", response.data.data);
        let temp = {},
          arr = [];
        for (let i = 0; i < response.data.data.length; i++) {
          temp = {
            name: response.data.data[i].name,
            id: response.data.data[i].id,
            hasChild: response.data.data[i].hasChild,
          };
          arr.push(temp);
          temp = {};
        }
        setAllCategories(arr);
      })
      .catch((error) => { });
  };
  const fetchSubCategories = (id) => {
    let uri = `${API_ENDPOINT}/sub-category?parent=${id}&all=true`;

    axios
      .get(uri, {
        headers: {
          "Accept-Language": lang,
        },
      })
      .then((response) => {
        console.log("category defe--> ", response.data.data);
        let temp = {},
          arr = [];
        for (let i = 0; i < response.data.data.length; i++) {
          temp = {
            name: response.data.data[i].name,
            id: response.data.data[i].id,
          };
          arr.push(temp);
          temp = {};
        }
        setAllSubCategories(arr);
      })
      .catch((error) => { });
  };
  const mouseEnter = (id, hasChild) => {
    console.log("Category hoveredddd:", id);
    sethasChild(true);
    fetchSubCategories(id);
  };
  string.setLanguage(lang);

  return (
    <div className="Header-layout">
      <div style={{ position: "relative" }}>
        <div style={{ width: "100%", position: "absolute", bottom: "0px" }}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            {remove ? (
              <Alert severity="error">{hint}</Alert>
            ) : (
                <Alert severity="success"> {hint}</Alert>
              )}
          </Snackbar>
        </div>
        <Navbar expand="lg">
          <div className="upperheader">
            <div className="upperheader-logo">
              <Navbar.Brand>
                <Link to="/Catch-It" onClick={() => setPathName("/Catch-It")}>
                  <img
                    src={lang === "ar" ? originallogo1 : originallogo2}
                    alt="imglogo"
                  />
                </Link>
              </Navbar.Brand>
            </div>
            <div className="upperheader-search">
              <div className="autoSearchDiv" style={{ direction: "rtl" }}>
                <Autocomplete
                  id="free-solo-demo"
                  freeSolo
                  value={SearchValue}
                  onChange={(event, newValue) => {
                    setSearchValue(newValue);
                  }}
                  options={AllProducts.map((option) => option.name[lang])}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={string.searchproductname}
                      value={productname}
                      onChange={(e) => {
                        setProductName(e.target.value);
                      }}
                    />
                  )}
                />
                <Button className="seachBtn">
                  {/* searchicon */}
                  <i
                    onClick={() => {
                      console.log("wwnnww=. ", productname);
                      console.log("wwww=. ", SearchValue);
                      if (SearchValue === "") {
                        props.handelFilter(productname);
                      } else {
                        props.handelFilter(
                          AllProducts.filter(
                            (item) => item.name[lang] === SearchValue
                          )
                        );
                      }
                      setProductName(null);
                      setSearchValue("");
                    }}
                    className="fas fa-search"
                    style={{ color: "#171717" }}
                  ></i>
                </Button>
              </div>
            </div>
            <div className="line-horz mx-2"></div>
            <div className="upperheader-icons">
              {/* {lang === "ar" ? (
                <span onClick={() => changeLang("en")}>EN</span>
              ) : (
                <span onClick={() => changeLang("ar")}>AR</span>
              )} */}
              <Link
                to="/Catch-It/ShoppingCart"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-shopping-cart">
                  {props.shoppingCardCount ? (
                    <span className="shoppingCount">
                      {props.shoppingCardCount}
                    </span>
                  ) : null}
                </i>
              </Link>
              <Link
                to="/Catch-It/Favourite"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-heart"></i>
              </Link>
              <Link
                to="/Catch-It/Notifications"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-bell">
                  {props.notification ? (
                    <span className="notifyCount">{props.notification}</span>
                  ) : null}
                </i>
              </Link>
            </div>
            <div className="line-horz mx-2"></div>
            <div className="upperheader-account">
              <div
                className={
                  lang === "en"
                    ? "ml-2 upperheader-BTNAccount"
                    : "mr-2 upperheader-BTNAccount"
                }
              >
                <Dropdown style={{ display: user ? "block" : "none" }}>
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="myAcc-dropDown"
                  >
                    <i
                      class="fas fa-user"
                      style={{ color: "#171717", paddingLeft: "10px" }}
                    ></i>
                    {string.muaccount}
                  </Dropdown.Toggle>
                  <p className="myAcc-username">{user ? user.name : null}</p>
                  <Dropdown.Menu className="myAcc-Menu" >
                    <Dropdown.Item>
                      <Link to="/Catch-It/MyOrders">
                        <i class="fas fa-shopping-basket pl-3"></i>
                        {string.myorders}
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <Link to="/Catch-It/ViewAddress">
                        <i class="fas fa-map-marker-alt pl-3"></i>
                        {string.addresslist}
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <Link to="/Catch-It/EditProfile">
                        <i class="fas fa-pen pl-3"></i>
                        {string.editprofile}
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item
                      // href="/Catch-It"
                      disabled={logOut}
                      onClick={() => LogOutfn()}
                    >
                      <Link to="/Catch-It">
                        <i class="fas fa-power-off pl-3"></i>
                        {string.logout}
                      </Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Button
                  style={{ display: user ? "none" : "block" }}
                  onClick={() => {
                    ToggleLoginForm();
                  }}
                >
                  {string.login}
                </Button>
              </div>
            </div>
          </div>
          <div className="responsive-header">
            <div className="responsive-logo">
              <Navbar.Brand>
                <Link to="/Catch-It" onClick={() => setPathName("/Catch-It")}>
                  <img
                    src={lang === "ar" ? originallogo1 : originallogo2}
                    alt="imglogo"
                  />
                </Link>
              </Navbar.Brand>
            </div>
            <div
              className="responsive-icons"
              style={{
                margin: lang === "ar" ? "0 auto 0 8px" : "0 8px 0 auto",
              }}
            >
              <Link
                to="/Catch-It/ShoppingCart"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-shopping-cart">
                  {props.shoppingCardCount ? (
                    <span
                      className="shoppingCount"
                      style={{
                        right: lang === "ar" ? "-10px" : "",
                        left: lang === "en" ? "-10px" : "",
                      }}
                    >
                      {props.shoppingCardCount}
                    </span>
                  ) : null}
                </i>
              </Link>
              <Link
                to="/Catch-It/Favourite"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-heart"></i>
              </Link>
              <Link
                to="/Catch-It/Notifications"
                className={lang === "ar" ? "ml-2" : "mr-2"}
              >
                <i className="fas fa-bell">
                  {props.notification ? (
                    <span
                      className="notifyCount"
                      style={{
                        right: lang === "ar" ? "-10px" : "",
                        left: lang === "en" ? "-10px" : "",
                      }}
                    >
                      {props.notification}
                    </span>
                  ) : null}
                </i>
              </Link>
            </div>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={() => setCloseMenu(!closemenu)}
            />
          </div>
          <Navbar.Collapse
            id="basic-navbar-nav"
            className={closemenu ? "closemenu" : "openmenu"}
          >
            <Nav
              style={{
                marginLeft: lang === "en" ? "3%" : "",
                marginRight: lang === "ar" ? "3%" : "",
              }}
            >
              <Link
                to="/Catch-It"
                onClick={() => {
                  setPathName("/Catch-It");
                  setCloseMenu(true);
                }}
                className={
                  pathName === "/Catch-It" ? "activeLink nav-link" : "nav-link"
                }
              >
                {string.Home}
              </Link>
              <div className="line-horz mx-2"></div>

              <NavDropdown
                title={string.Categories}
                id="basic-nav-dropdown"
                style={{ width: "fit-content" }}
              >
                <div style={{ display: "flex" }}>
                  {console.log("AllCategories", AllCategories)}
                  <div className="categories-section">
                    {AllCategories.map((category, index) => {
                      return (
                        <NavDropdown.Item
                          onMouseEnter={() =>
                            mouseEnter(category.id, category.hasChild)
                          }
                        >
                          <Link
                            to={{
                              pathname: `/Catch-It/Categories/${category.id}`,
                              // state: { id: category.id },
                            }}
                            className={
                              pathName === "/Catch-It/Categories"
                                ? "activeLink"
                                : ""
                            }
                          >
                            {category.name}
                          </Link>
                        </NavDropdown.Item>
                      );
                    })}
                  </div>
                  {hasChild && AllSubCategories.length > 0 && (
                    <div className="subcategories-section">
                      {AllSubCategories.map((subCategory, index) => {
                        return (
                          <NavDropdown.Item href={`/Catch-It/Categories/${subCategory.id}`}>
                            {subCategory.name}
                          </NavDropdown.Item>
                        );
                      })}

                      {/* <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                      <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                      <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item> */}
                    </div>
                  )}
                </div>
              </NavDropdown>
              <div className="line-horz mx-2"></div>
              <Link
                to="/Catch-It/about-us"
                onClick={() => {
                  setCloseMenu(true);
                  setPathName("/Catch-It/about-us");
                }}
                className={
                  pathName === "/Catch-It/about-us"
                    ? "activeLink nav-link"
                    : "nav-link"
                }
              >
                {string.Aboutus}
              </Link>
              <div className="line-horz mx-2"></div>
              <Link
                to="/Catch-It/contact-us"
                onClick={() => {
                  setCloseMenu(true);
                  setPathName("/Catch-It/contact-us");
                }}
                className={
                  pathName === "/Catch-It/contact-us"
                    ? "activeLink nav-link"
                    : "nav-link"
                }
              >
                {string.Contactus}
              </Link>
              {user ? (
                <NavDropdown
                  title={string.muaccount}
                  id="basic-nav-dropdown"
                  className="myAcc-reponsive"
                  style={{ width: "fit-content" }}
                >
                  <div style={{ display: "flex" }}>
                    <div className="categories-section">
                      <NavDropdown.Item
                        // href="/Catch-It/MyOrders"
                        onClick={() => setCloseMenu(true)}
                      >
                        <Link to="/Catch-It/MyOrders">
                          <i class="fas fa-shopping-basket pl-3"></i>
                          {string.myorders}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        onClick={() => setCloseMenu(true)}
                      >
                        <Link to="/Catch-It/ViewAddress">
                          <i class="fas fa-map-marker-alt pl-3"></i>
                          {string.addresslist}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        onClick={() => setCloseMenu(true)}
                      >
                        <Link to="/Catch-It/Profile">
                          <i class="fas fa-pen pl-3"></i>
                          {string.editprofile}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href=""
                        disabled={logOut}
                        onClick={() => LogOutfn()}
                      >
                        <i class="fas fa-power-off pl-3"></i>
                        {string.logout}
                      </NavDropdown.Item>
                    </div>
                  </div>
                </NavDropdown>
              ) : (
                  <Link
                    to="/Catch-It/contact-us"
                    onClick={() => {
                      ToggleLoginForm();
                    }}
                    className="login-reponsive"
                  >
                    {string.login}
                  </Link>
                )}
            </Nav>

            {/* <div
              className="responsive-account"
              onClick={() => setCloseMenu(true)}
            >
              {user ? (
                // <Link
                //   onClick={() => {
                //     setPathName("/Catch-It/Profile");
                //   }}
                //   to="/Catch-It/Profile"
                // >
                //   {string.muaccount}
                // </Link>
                <Dropdown style={{ display: user ? "block" : "none" }} >
                  <Dropdown.Toggle variant="success" id="dropdown-basic" className="myAcc-dropDown">
                    <i class="fas fa-user" style={{ color: "#171717", paddingLeft: '10px' }}></i>
                    {string.muaccount}
                  </Dropdown.Toggle>
                  <p className="myAcc-username">maha taha</p>
                  <Dropdown.Menu className="myAcc-Menu">
                    <Dropdown.Item href="/Catch-It/MyOrders"><i class="fas fa-shopping-basket pl-3"></i>{string.myorders}</Dropdown.Item>
                    <Dropdown.Item href="/Catch-It/ViewAddress"><i class="fas fa-map-marker-alt pl-3"></i>{string.addresslist}</Dropdown.Item>
                    <Dropdown.Item href="/Catch-It/Profile"><i class="fas fa-pen pl-3"></i>{string.editprofile}</Dropdown.Item>
                    <Dropdown.Item href="" disabled={logOut}
                      onClick={() => LogOutfn()}><i class="fas fa-power-off pl-3"></i>{string.logout}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                  <Link
                    to="/Catch-It/contact-us"
                    onClick={() => {
                      ToggleLoginForm();
                    }}
                  >
                    {string.login}
                  </Link>
                )}
            </div> */}

            <div
              className={
                lang === "ar"
                  ? "responsive-search right signAR"
                  : "responsive-search"
              }
            >
              <Autocomplete
                id="free-solo-demo"
                freeSolo
                value={SearchValue}
                onChange={(event, newValue) => {
                  setSearchValue(newValue);
                }}
                options={AllProducts.map((option) => option.name[lang])}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={string.searchproductname}
                    value={productname}
                    onChange={(e) => {
                      setProductName(e.target.value);
                    }}
                  />
                )}
              />

              <div className="searchicon">
                <i
                  onClick={() => {
                    if (SearchValue === "") {
                      props.handelFilter(productname);
                    } else {
                      props.handelFilter(
                        AllProducts.filter(
                          (item) => item.name[lang] === SearchValue
                        )
                      );
                    }
                    setProductName(null);
                    setSearchValue("");
                    setCloseMenu(true);
                  }}
                  className="fas fa-search"
                ></i>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
        {openLoginForm && <LoginForm close={ToggleLoginForm} />}

        <Modal
          show={showlogin}
          onHide={handleCloseLoginModal}
          animation={false}
          className="cardmodal specialstyleModalFooter headermodallogin"
        >
          <Modal.Dialog>
            <Modal.Header>
              <img src={close} onClick={handleCloseLoginModal} alt="close" />
            </Modal.Header>
            <Modal.Body>
              <div>
                <div>
                  <img src={should} alt="logo" style={{ width: "150px" }} />
                </div>
                <p>{string.firstlogin}</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-block"
                onClick={() => {
                  handleCloseLoginModal();
                  ToggleLoginForm();
                }}
                style={{ backgroundColor: "#0071BC" }}
              >
                {string.login}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>

        <Modal
          className="cardmodal"
          show={showImage}
          onHide={handleCloseImageModal}
          animation={false}
        >
          <Modal.Dialog>
            <Modal.Header className="justify-content-center">
              {lang === "en" ? (
                <img
                  className={"closeBTNAR"}
                  src={close}
                  onClick={handleCloseImageModal}
                  alt="close"
                />
              ) : null}
              <p>{string.addorderimg}</p>
              {lang === "ar" ? (
                <img
                  className="closeBTNAR"
                  src={close}
                  onClick={handleCloseImageModal}
                  alt="close"
                />
              ) : null}
            </Modal.Header>
            <Modal.Body>
              <div>
                <div>
                  <img
                    src={imagePreviewUrl}
                    alt="logo"
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="mt-3">
                  <Button
                    className="btn-block"
                    onClick={() => {
                      MannualOrder();
                    }}
                    style={{ backgroundColor: "#0071BC" }}
                  >
                    {string.sendBTN}
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal.Dialog>
        </Modal>

        <div
          className={lang === "ar" ? "searchdive signAR" : "searchdive"}
          style={{ display: showSearch ? "flex" : "none" }}
        >
          <Autocomplete
            id="free-solo-demo"
            freeSolo
            value={SearchValue}
            onChange={(event, newValue) => {
              setSearchValue(newValue);
            }}
            options={AllProducts.map((option) => option.name[lang])}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={string.searchproductname}
                value={productname}
                onChange={(e) => {
                  setProductName(e.target.value);
                }}
              />
            )}
          />
          <div className="searchicon">
            <i
              onClick={() => {
                console.log("wwnnww=. ", productname);
                console.log("wwww=. ", SearchValue);
                if (SearchValue === "") {
                  props.handelFilter(productname);
                } else {
                  props.handelFilter(
                    AllProducts.filter(
                      (item) => item.name[lang] === SearchValue
                    )
                  );
                }
                setProductName(null);
                setSearchValue("");
              }}
              className="fas fa-search"
            ></i>
          </div>
        </div>
      </div>
      <div
        className="fixedwhatsicon"
        style={{ left: "15px" }}
      >
        {data && data.whatsappNumber !== "" ? (
          <Link to="/Catch-It/chat">
            <span className="chat-icon">
              {/* <i className="fas fa-comment-alt"></i> */}
              <img src={chaticon} alt="chaticon" />

            </span>
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
